import { api } from "./client";
import type { PagedResult } from "@/types/api";
import type {
  CreatePartyRequest,
  OwnedEntityDto,
  OwnedEntityRequest,
  PartyContactDto,
  PartyContactRequest,
  PartyDetailDto,
  PartyListItemDto,
  PartyListQuery,
  PartyType,
  UpdatePartyRequest,
} from "@/types/parties";
import { partyBasePath } from "@/types/parties";

// Party read-flip (WS-A) — Borrower/Seller party REST endpoints. Backend:
//   src/PhoenixCapital.Api/Controllers/Parties/{Borrowers,Sellers}Controller.cs
// One api object parameterized by PartyType; the base path picks the
// type-scoped controller.

export const partiesApi = {
  list: (type: PartyType, query?: PartyListQuery) =>
    api.get<PagedResult<PartyListItemDto>>(partyBasePath(type), query),
  get: (type: PartyType, id: string) =>
    api.get<PartyDetailDto>(`${partyBasePath(type)}/${id}`),
  create: (type: PartyType, body: CreatePartyRequest) =>
    api.post<PartyDetailDto>(partyBasePath(type), body),
  update: (type: PartyType, id: string, body: UpdatePartyRequest) =>
    api.put<PartyDetailDto>(`${partyBasePath(type)}/${id}`, body),
  archive: (type: PartyType, id: string) =>
    api.delete<void>(`${partyBasePath(type)}/${id}`),
  upsertContact: (type: PartyType, partyId: string, body: PartyContactRequest) =>
    api.post<PartyContactDto>(`${partyBasePath(type)}/${partyId}/contacts`, body),
  deleteContact: (type: PartyType, partyId: string, contactId: string) =>
    api.delete<void>(`${partyBasePath(type)}/${partyId}/contacts/${contactId}`),
  upsertOwnedEntity: (type: PartyType, partyId: string, body: OwnedEntityRequest) =>
    api.post<OwnedEntityDto>(`${partyBasePath(type)}/${partyId}/owned-entities`, body),
  deleteOwnedEntity: (type: PartyType, partyId: string, ownedEntityId: string) =>
    api.delete<void>(`${partyBasePath(type)}/${partyId}/owned-entities/${ownedEntityId}`),
};
